import { getEnv } from "../services/AppService";

const ENV_PROD = "prod";
const ENV_PREPROD = "dit-cfi-pdx";

class DigitalDataForGtm {
  constructor() {
    this.event = [];
    this.page = {};
    this.site = {};
    this.user = {};

    this.setSiteEnv();
  }

  setProp(prop, obj) {
    if (typeof obj === "object") {
      const newUserObj = {
        ...this[prop]
      };
      Object.keys(obj).forEach(key => {
        newUserObj[key] = obj[key];
      });
      this[prop] = newUserObj;
    } else {
      throw new Error("function param should be an object");
    }
  }

  pushEvent(obj) {
    this.event.push(obj);
  }

  setPage(obj) {
    return this.setProp("page", obj);
  }

  setSite(obj) {
    return this.setProp("site", obj);
  }

  setSiteEnv() {
    const env = getEnv() === "prod" ? ENV_PROD : ENV_PREPROD;
    return this.setSite({ env });
  }

  setUser(obj) {
    return this.setProp("user", obj);
  }
}

export const injectDigitalDataForGtm = () => {
  window.digitalData = window.digitalData || new DigitalDataForGtm();
};
